import { observer } from 'mobx-react';
import { FC } from 'react';

import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';

import { AnalyticsStore } from '../stores/analytics.store';

export const AnalyticsPage: FC = provide({
    singletons: [AnalyticsStore],
})(
    observer(() => {
        const [{ data, source, basename }] = useDependencies(AnalyticsStore);

        return (
            <Loader
                basename={basename}
                src={source}
                loadingFallback={<CenteredSpinner />}
                className="w-100"
                data={data}
            />
        );
    }),
);
